// Mesma forma de evento usada no protótipo validado com o Google Tag Manager
// (container GTM-NNB2V962): empurra {event: nome, ...params} pro dataLayer,
// que é o formato que o gatilho "CE - eventos do site" (Custom Event) espera.
export function trackEvent(name, params) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: name }, params || {}));
}
